<template>
  <div :class="`as-parent-lineups as-parent-lineups-${siteName}`">
    <TabsBtn
      :tabs="tabs"
      :activeTab="activeTab"
      @change="changeTab"
      :isShowBorder="true"
    />

    <div v-if="lineups" class="as-scrolling as-scrolling__result-popup">
      <SquadTab
        v-if="activeTab === 'squad'"
        :match="match"
        :lineups="lineups"
        :startingPlayers="startingPlayers[1].data"
      />
      <div v-else-if="activeTab === 'players'">
        <PlayerTeamTab :match="match" :lineups="lineups" />
        <h2 class="as-h2-title-box">ĐỘI HÌNH RA SÂN</h2>
        <PlayersTab
          :match="match"
          :lineups="lineups"
          :startingPlayers="startingPlayers[0].data"
        />
        <h2 class="as-h2-title-box">Dự bị</h2>
        <PlayersTab
          :match="match"
          :lineups="lineups"
          :startingPlayers="startingPlayers[1].data"
          :isSubstituted="true"
        />
      </div>
      <div v-else-if="activeTab === 'injuries_suspensions'">
        <PlayerTeamTab :match="match" :lineups="lineups" />
        <PlayersTab
          :match="match"
          :lineups="lineups"
          :startingPlayers="startingPlayers[2].data"
          :isInjuredSuspended="true"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { ILineups, IMatch, IPlayer } from "~src/interfaces";
import SquadTab from "~src/components/lineups/SquadTab.vue";
import PlayerTeamTab from "~src/components/lineups/PlayerTeamTab.vue";
import PlayersTab from "~src/components/lineups/PlayersTab.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  lineups: ILineups;
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {});
const siteName = computed(() => commonStore.getSiteName);

const activeTab = ref("squad");

const tabs = [
  {
    title: "Sơ đồ",
    key: "squad",
  },
  {
    title: "Ra sân",
    key: "players",
  },
  {
    title: "Chấn thương & treo giò",
    key: "injuries_suspensions",
  },
];

const changeTab = (val: string) => {
  activeTab.value = val;
};

const startingPlayers = computed(() => {
  let result = [
    {
      type: "Starting Lineups",
      data: { home: <Array<IPlayer>>[], away: <Array<IPlayer>>[] },
    },
    { type: "Substitutes", data: { home: [], away: [] } },
    { type: "Injured or suspended", data: { home: [], away: [] } },
  ];
  try {
    let flag = false;
    try {
      const lineupSideHome = props.lineups?.lineup?.home || null;
      if (lineupSideHome) {
        for (const player of lineupSideHome) {
          if (player.first === 1) {
            result[0].data.home.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.home.push(player);
            flag = true;
          }
        }
      }
      const lineupSideAway = props.lineups?.lineup?.away || null;
      if (lineupSideAway) {
        for (const player of lineupSideAway) {
          if (player.first === 1) {
            result[0].data.away.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.away.push(player);
            flag = true;
          }
        }
      }

      if (props.lineups && props.lineups.id && props.lineups.injury.home) {
        result[2].data.home = props.lineups.injury.home;
        flag = true;
      }
      if (props.lineups && props.lineups.id && props.lineups.injury.away) {
        result[2].data.away = props.lineups.injury.away;
        flag = true;
      }
    } catch (e) {
      console.error(e);
    }
  } catch (error) {
    console.log(error);
  }

  return result;
});
</script>

<script lang="ts">
export default {};
</script>
